module.exports = __webpack_public_path__ + "static/media/houses2.51c1e922.webp";